import { ArrowRight, Package } from '../ui/icons';
import { Link } from 'react-router-dom';

interface CatalogCtaProps {
  label: string;
  className?: string;
}

export default function CatalogCta({ label, className = '' }: CatalogCtaProps) {
  return (
    <Link to="/products" className={`btn-glass-primary inline-flex items-center gap-2 whitespace-nowrap rounded-xl px-6 py-3 text-base font-semibold shadow-md shadow-brand/10 animate-[logo-glow-pulse-box_8s_ease-in-out_infinite] ${className}`}>
      <Package className="h-4 w-4" />
      {label}
      <ArrowRight className="h-4 w-4" />
    </Link>
  );
}
